import { Text } from "../../../../../packages/ui-kit";
import image from "../../../../../packages/images/unavailable-pic.svg";
import { DICTIONARY } from "../../../dictionary";
import styles from "./chat-error.module.scss";

const LOCALE = DICTIONARY.CHAT_CREATE_ERROR;

export const ChatCreateError = () => {
  const img = (
    <img
      data-test-id="chat-error-banner"
      className={styles.icon}
      src={image}
      alt={LOCALE.TITLE}
    />
  );

  const title = (
    <Text
      data-test-id="chat-error-title"
      className={styles.title}
      size="large"
      weight="medium"
    >
      {LOCALE.TITLE}
    </Text>
  );

  const subtitle = (
    <Text className={styles["sub-title"]}>{LOCALE.SUB_TITLE}</Text>
  );

  return (
    <div data-test-id="chat-error-banner" className={styles.banner}>
      {img}
      {title}
      {subtitle}
    </div>
  );
};
